export default "__VITE_ASSET__CRyNSz6R__"